module.exports = __webpack_public_path__ + "static/media/sms.05dee59c.png";